function UserNav(){
    return(
        <div className="over_nav">
        <div className="nav_user">
        <p><i className="fa-solid fa-sliders"></i> Akoonkaaga</p>
        <ul className="in_home">
            <li>
                <a href="">
                <i className="fa-brands fa-hashnode"></i> Home 
                </a>
            </li>
            <li>
                <a href="">
                <i className="fa-solid fa-calculator"></i> Sako Xisaabi
                </a>
            </li>
            <li>
                <a href="">
                <i className="fa-solid fa-coins"></i> Dhaxal Xisaabi
                </a>
            </li>
            <li>
                <a href="">
                <i className="fa-solid fa-file-invoice-dollar"></i> Rasiido Dhaxal 
                </a>
            </li>
            <li>
                <a href="">
                <i className="fa-solid fa-gear"></i> Akoon setting
                </a>
            </li>
        </ul>
        </div>
    </div>
    )
}


export default UserNav